import React from 'react';
import styles from './GenericModal.module.css';
import GenericIconButton from './GenericIconButton';

interface GenericModalProps {
  isVisible: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: string;
  height?: string;
}

const GenericModal: React.FC<GenericModalProps> = ({ isVisible, onClose, title, children, width = "40%", height = "" }) => {
    if (!isVisible) return null;
  
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} style={{ width: width, height: height }}>
        
        {title!="" ? (<div className={styles.modalHeader}>
          <span>{title}</span>
          <GenericIconButton icon='light/times.svg' width='15px' height='15px' onClick={ onClose }/>
        </div>) : ""}
        <div className={styles.modalBody}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default GenericModal;
